import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";
// import Checkbox from "@material-ui/core/Checkbox";
// import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import "react-quill/dist/quill.snow.css";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { puushdotPoolService } from "services/puushdotPoolService";
// import { Link, useParams, useHistory } from "react-router-dom";
import { useParams, useHistory } from "react-router-dom";
import Button from "../../components/CustomButtons/Button";
import { Box } from "@material-ui/core";
// import { Edit } from "@material-ui/icons";
import { chainOptions } from "const";
import RetroPoolIndex from "views/PuushdotPool/RetroPoolIndex";

const useStyles = makeStyles(styles);

export default function PuushdotPoolView() {
  const { id } = useParams();
  const history = useHistory();
  const [info, setInfo] = React.useState({});

  async function fetchData(id) {
    const { data } = await puushdotPoolService.view(id);
    setInfo(data);
  }

  const getChainById = (id) => {
    const chain = chainOptions().find((c) => +c.value === +id);
    return chain ? chain.label : "Null";
  };

  React.useEffect(() => {
    fetchData(id);
  }, []);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Contacts />
            </CardIcon>
            <h4 className={classes.cardIconTitle}> Name: {info.name} </h4>
          </CardHeader>

          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Collection ID:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.collectionId}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Owner Address:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.ownerAddress}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Address:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.address}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Puush Fee Receiver:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.puushFeeReceiver}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Puush Fee Amount:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{info.puushFeeAmount}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <h5>
                  <strong>Chain ID:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={9}>
                <h5>{getChainById(info.chainId)}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer className="ml-2">
              <Box m={2} pt={3}>
                <Button onClick={() => history.goBack()}>Cancel</Button>
              </Box>
              {/* <Box m={2} pt={3}>
                <Link to={"/admin/pup404/edit/" + info._id}>
                  <Button color="info" className="ml-2">
                    {" "}
                    <Edit /> Edit
                  </Button>
                </Link>
              </Box> */}
            </GridContainer>
            <h4>
              <strong>Pools List: </strong>
            </h4>
            <RetroPoolIndex items={info?.retropools || []} />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
